export const reservationCategories = [
    { value: 'sc', text: 'SC' },
    { value: 'st', text: 'ST' },
    { value: 'obc', text: 'OBC' },
    { value: 'general', text: 'General' },
    { value: 'ews', text: 'EWS' },
    { value: 'others', text: 'Others' },
  ];
  